require('../scss/main.scss');
require('../../patterns/assets/scss/styleguide.scss');
// require.context (provided by webpack) recursively requires all files in a folder
require.context('../img/');
require('./main.js');
